// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".full-height-div[data-v-34f21437]{height:calc(100vh - 180px);width:100%;overflow-y:auto;overflow-x:hidden}", ""]);
// Exports
module.exports = exports;
